<template>
  <hit-form-definition-builder-base-component
    :validations="validations"
    :value="value"
  >
    <template #default="{formData, validationState, changeField}">
      <hit-select
        :value="formData.reference"
        :options="entityOptions"
        name="reference"
        :label="t('hit-base.form.entity')"
        :validation-state="validationState.reference"
      />
      <tag-list
        v-if="tagEnabled(formData)"
        :label="t('hit-base.common.tags')"
        :tag-object-list="tagList"
        :tag-entities-to-load="[formData.reference]"
        :data-service="DataService"
        @change="(data) => changeTag(data, changeField)"
      />
    </template>
  </hit-form-definition-builder-base-component>
</template>

<script>
import HitFormDefinitionBuilderBaseComponent from './HitFormDefinitionBuilderBaseComponent';
import {useI18n} from 'vue-i18n';
import TagList from '@hit/components/src/components/list/TagList.vue';
import {HitSelect} from '@hit/components';
import {DataService} from '../../../../../api';

export default {
  name: 'EntityComponentForm',
  computed: {
    DataService() {
      return DataService;
    },
  },
  components: {
    HitFormDefinitionBuilderBaseComponent,
    HitSelect,
    TagList,
  },
  props: {
    /**
     * Entity component of the builder to edit
     */
    value: {
      type: Object,
      required: true,
    },
    /**
     * Validations for the entity component
     */
    validations: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const {t} = useI18n();
    return {t};
  },
  data() {
    return {
      tagList: [],
      entityOptions: [
        {
          id: 'staff',
          label: this.t('hit-base.common.staff-short'),
        },
        {
          id: 'equipment',
          label: this.t('hit-base.common.equipment', 1),
        },
        {
          id: 'country',
          label: this.t('hit-base.common.country'),
        },
        {
          id: 'address',
          label: this.t('hit-base.common.address', 1),
        },
        {
          id: 'project',
          label: this.t('hit-base.common.project', 1),
        },
        {
          id: 'project_part',
          label: this.t('hit-base.common.project-part', 1),
        },
        {
          id: 'project_part_item',
          label: this.t('hit-base.common.project-part-item', 1),
        },
        {
          id: 'resource',
          label: this.t('hit-base.common.resource', 1),
        },
      ],
    };
  },

  methods: {
    tagEnabled(formData) {
      return (
        formData?.reference &&
        !['project_part_item', 'country'].includes(formData?.reference)
      );
    },
    /**
     * Tag changes are registered in the value attribute when clicking save button
     * We need to manually regenerate the tag list to make the change visible
     */
    changeTag(data, changeField) {
      changeField('tagList', data);
      this.generateTagList(data);
    },

    /**
     * In the form definition, we only store the UUID and not the object
     */
    generateTagList(forceTagUuids = null) {
      const tags = forceTagUuids ? forceTagUuids : this.value?.tagList ?? [];
      if (tags.length > 0 ?? false) {
        DataService.read('tag', {
          attributes: 'id, designation, colour',
          filters: {id: `in.(${tags.join(',')})`},
        }).then((res) => {
          if (res && res.data) {
            this.tagList = res.data;
          }
        });
      } else {
        this.tagList = [];
      }
    },
  },

  /**
   * When the component is mounted, we need to generate the object list for the selected tags
   */
  mounted() {
    this.generateTagList();
  },

  /**
   * The save and cancel event is emitted inside the HitFormDefinitionBuilderBaseComponent
   * We do not catch it here and do not define the events in this component. Like this,
   * the event listeners added to this component propagates to the base builder
   */
  emits: [],
};
</script>

<style scoped></style>
